import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/components/index'
import aboutus from '@/components/aboutus'
import newsList from '@/components/newsList'
import donation_projects from '@/components/donation_projects'
import donation_thank from '@/components/donation_thank'
import infoOpen from '@/components/infoOpen'
import donation_guide from '@/components/donation_guide'
import download from '@/components/download'
import person from '@/components/person'
import login from '@/components/login'
import reset from '@/components/reset'
import register from '@/components/register'

import invoiceform from '@/components/formbox/invoiceform'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/pc/',
  routes: [
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
		{
		  path: '/',
		  name: 'index',
		  component: index
		},
		{
		  path: '/aboutus',
		  name: 'aboutus',
		  component: aboutus
		},
		{
		  path: '/newsList',
		  name: 'newsList',
		  component: newsList
		},

		// 捐赠项目
		{
		  path: '/donation_projects',
		  name: 'donation_projects',
		  component: donation_projects
		},
		{
		  path: '/donation_thank',
		  name: 'donation_thank',
		  component: donation_thank
		},
			{
		  path: '/infoOpen',
		  name: 'infoOpen',
		  component: infoOpen
		},
		{
		  path: '/donation_guide',
		  name: 'donation_guide',
		  component: donation_guide
		},
		{
		  path: '/download',
		  name: 'download',
		  component: download
		},
		{
		  path: '/person',
		  name: 'person',
		  component: person
		},
		{
		  path: '/login',
		  name: 'login',
		  component: login
		},
			{
		  path: '/reset',
		  name: 'reset',
		  component: reset
		},
		{
		  path: '/register',
		  name: 'register',
		  component: register
		},

		{
		  path: '/invoiceform',
		  name: 'invoiceform',
		  component: invoiceform
		},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js